import { Link, Stack, useRouter } from 'expo-router';
import { StyleSheet, Text, View, SafeAreaView, TouchableOpacity, Platform } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';
import { Home, ArrowLeft } from 'lucide-react-native';
import React, { useEffect } from 'react';

export default function NotFoundScreen() {
  const { colors } = useTheme();
  const router = useRouter();

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    if (typeof window === 'undefined') return;

    const pathname = window.location.pathname || '';
    const search = window.location.search || '';
    const hash = window.location.hash || '';

    if (pathname.startsWith('/(auth)/update-password')) {
      router.replace((`/update-password${search}${hash}`) as any);
      return;
    }

    if (pathname.startsWith('/poenoracha.com.br/login')) {
      const rest = pathname.slice('/poenoracha.com.br/login'.length);
      const query = rest.startsWith('&') ? `?${rest.slice(1)}` : '';
      router.replace((`/login${query}${search}${hash}`) as any);
    }

    if (pathname.startsWith('/poenoracha.com.br/update-password')) {
      const rest = pathname.slice('/poenoracha.com.br/update-password'.length);
      const query = rest.startsWith('&') ? `?${rest.slice(1)}` : '';
      router.replace((`/update-password${query}${search}${hash}`) as any);
    }
  }, [router]);

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    content: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
    },
    errorCode: {
      fontSize: 72,
      fontWeight: '800',
      color: colors.primary,
      marginBottom: 16,
    },
    title: {
      fontSize: 24,
      fontWeight: '600',
      color: colors.text,
      textAlign: 'center',
      marginBottom: 8,
    },
    subtitle: {
      fontSize: 16,
      color: colors.textSecondary,
      textAlign: 'center',
      marginBottom: 32,
      lineHeight: 22,
    },
    button: {
      backgroundColor: colors.primary,
      paddingHorizontal: 24,
      paddingVertical: 12,
      borderRadius: 8,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    buttonText: {
      color: '#FFFFFF',
      fontSize: 16,
      fontWeight: '600',
    },
  });

  return (
    <>
      <Stack.Screen options={{ 
        title: 'Página não encontrada',
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: colors.text,
      }} />
      <SafeAreaView style={styles.container}>
        <View style={styles.content}>
          <Text style={styles.errorCode}>404</Text>
          <Text style={styles.title}>Página não encontrada</Text>
          <Text style={styles.subtitle}>
            A página que você está procurando não existe ou foi movida.
          </Text>
          <Link href="/" asChild>
            <TouchableOpacity style={styles.button}>
              <Home size={20} color="#FFFFFF" />
              <Text style={styles.buttonText}>Voltar ao início</Text>
            </TouchableOpacity>
          </Link>
        </View>
      </SafeAreaView>
    </>
  );
}
